module.exports = __webpack_public_path__ + "static/media/dashboard-icon-inactive.8e2a7459.svg";